__turbopack_context__.v({
  "backButton": "index-module-scss-module__3VwbTW__backButton",
  "navigation": "index-module-scss-module__3VwbTW__navigation",
});
